import { render, staticRenderFns } from "./RankPerson.vue?vue&type=template&id=4369e8a6&"
import script from "./RankPerson.vue?vue&type=script&lang=js&"
export * from "./RankPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports